<template>
  <div class="lms-editor">
    <div class="flex-grow ml-auto mb-8">
      <linput
        type="text"
        name="fname"
        v-model="form.title"
        :error="errors.title"
        placeholder="Title of Article"
      />
    </div>
    <div class="rounded">
      <div style="height: 500px" ref="editor" class="dmain mb-1"></div>
    </div>
    <div class="flex flex-col justify-center items-center">
      <div class="mt-8">
        <lms-button @click="submitArticle">Create Article</lms-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Quill from "quill";
import { store } from "@/store/store";
import axios from "axios"
export default {
  name: "editor",
  data() {
    return {
      editor: "",
      image: null,
      form: {},
      errors: {},
    };
  },
  components: {
    linput: () => import("@/components/general/input"),
    LmsButton: () => import("@/components/general/button"),
  },
  mounted() {

    let options = {
      // debug: "info",
      placeholder: "Create an article...",
      theme: "snow",
      modules: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, 4, 5, false] }],
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            ["image", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
              ["link"]
          ],
            bounds: document.body,
            theme: "snow",
            handlers: {
                link: function(value) {
                    if (value) {
                        let href = prompt("Enter the URL");
                        this.quill.format("link", href);
                    } else {
                        this.quill.format("link", false);
                    }
                },
                image: async function() {
                    let fileInput = this.container.querySelector(
                        "input.ql-image[type=file]"
                    );

                    if (fileInput == null) {
                        fileInput = document.createElement("input");
                        fileInput.setAttribute("type", "file");
                        fileInput.setAttribute(
                            "accept",
                            "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"
                        );
                        fileInput.classList.add("ql-image");
                        fileInput.addEventListener("change", () => {
                            const files = fileInput.files;
                            const range = this.quill.getSelection(true);

                            if (!files || !files.length) {
                                console.log("No files selected");
                                return;
                            }

                            const formData = new FormData();
                            formData.append("asset_file", files[0]);
                            this.quill.enable(false);
                            axios
                                .post(`${process.env.VUE_APP_API}/tenant/asset/upload-to-bucket`,formData,{
                                    headers: {
                                        "content-type": "multipart/form-data",
                                        Authorization: `Bearer ${store.state.auth.token}`,
                                    },
                                })
                                .then(res => {
                                    this.quill.enable(true);
                                    this.quill.editor.insertEmbed(
                                        range.index,
                                        "image",
                                        res.data.data.file_url
                                    );
                                    this.quill.setSelection(
                                        range.index + 1,
                                        Quill.sources.SILENT
                                    );
                                    fileInput.value = "";
                                })
                                .catch(ex => {
                                    console.log("quill image upload failed");
                                    console.log(error);
                                    this.quill.enable(true);
                                });
                            // const self = this;
                            // reader.onload = async () => {
                            //     let encoded = reader.result
                            //         .toString()
                            //         .replace(/^data:(.*,)?/, "");
                            //     if (encoded.length % 4 > 0) {
                            //         encoded += "=".repeat(4 - (encoded.length % 4));
                            //     }
                            //     self.image = "data:image/jpg/gif/png;base64," + encoded;
                            //
                            // };
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                }
            }
        },

      },
    };
    this.editor = new Quill(this.$refs.editor, options);
  },
  methods: {
    ...mapActions(["createTenantArticle"]),
    ...mapMutations(["updateLoader"]),
    async submitArticle() {
      this.form.article = this.$refs.editor.innerHTML;
      this.form.article_normal_text = this.$refs.editor.innerText;
      if (
        typeof this.form.title == "undefined" ||
        this.form.article_normal_text == ""
      ) {
        this.$emit("notify", {
          type: "error",
          message: "You cannot create an empty article",
        });
        return;
      }

      this.updateLoader(true);
      let res = await this.createTenantArticle(this.form);
      this.updateLoader(false);

      if (res.status == 200 || res.status == 201) {
        this.form = {};
        this.$refs.editor.innerHTML = "<p></p>";
        this.$emit("notify", {
          type: "success",
          message: "Article created successfully",
        });
        this.$router.push({ name: "tenant-resources" });
      } else {
        this.loading = false;
        this.handleNotify({
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
    updateLink(link) {
    // add protocol if not there yet

    }

  },
};
</script>
<style lang="scss" scoped>
.lms-editor {
}
</style>
